import OrderAccess from './OrderAccess';
import { OrderDetailsContent } from './OrderDetails';

const MyOrderDetails = () => (
  <OrderAccess own>{() => <OrderDetailsContent consultantView />}</OrderAccess>
);

export default MyOrderDetails;
